import { WorksheetChartSection, WorksheetResultsSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ResultsMessagesSection } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import React from 'react';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import ResultsCalculatedPropertiesSection from './ResultsCalculatedPropertiesSection';
import ResultsChartOptionsSection from './ResultsChartOptionsSection';
import ResultsChecksSection from './ResultsChecksSection';

let ResultsPageSection: React.FC<IWorksheetComponent> = () => (
  <WorksheetResultsSection heading="Results">
    <ResultsChartOptionsSection />
    <NamePrefixModifier namePrefix="chart">
      <WorksheetChartSection wide />
    </NamePrefixModifier>
    <ResultsMessagesSection />
    <ResultsChecksSection />
    <ResultsCalculatedPropertiesSection />
  </WorksheetResultsSection>
);

ResultsPageSection = withInjectedProps(ResultsPageSection);

export { ResultsPageSection };
export default ResultsPageSection;
